import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

import './TimezonePicker.scss';

// Build the list of options for timezones
const TIMEZONE_OPTIONS = moment.tz.names().map((name) => ({
	value: name,
	label: name.replace('_', ' '),
}));

const propTypes = {

	/**
	 * The input id.
	 */
	id: PropTypes.string.isRequired,

	/**
	 * The input name.
	 */
	name: PropTypes.string.isRequired,

	/**
	 * The input timezone value.
	 */
	value: PropTypes.string.isRequired,

	/**
	 * The input placeholder text (if any).
	 */
	placeholder: PropTypes.string,

	/**
	 * True, if the input timezone value is invalid.
	 */
	isInvalid: PropTypes.bool.isRequired,

	/**
	 * The input on change callback function.
	 */
	onChange: PropTypes.func.isRequired,

};

/**
 * Form component that can be used to select a specific timezone from
 * the list of options provided by moment-timezone.
 *
 * @param {Object} props  The component props.
 *
 * @returns {Object}  The TimezonePicker component.
 */
const TimezonePicker = (props) => {

	const {
		id,
		name,
		value,
		placeholder,
		isInvalid,
		onChange,
	} = props;

	return (
		<ReactSelect
			id={id}
			name={name}
			className={`
				tc-timezonepicker
				${isInvalid ? 'is-invalid' : ''}
			`}
			classNamePrefix="tc-timezonepicker"
			// Convert value to format expected by react-select
			value={value ? { label: value, value } : null}
			placeholder={placeholder}
			options={TIMEZONE_OPTIONS}
			components={{
				DropdownIndicator: null, // Hide this
				IndicatorSeperator: null, // Hide this
			}}
			onChange={(change) => onChange(change?.value)} />
	);

};

TimezonePicker.propTypes = propTypes;

export default TimezonePicker;
